/**
 * lerna-alias package needs index.js file in package root to work correctly
 */

import Colors from './design-system-colors';

export default Colors;
